module.exports = __webpack_public_path__ + "static/media/291492.690036e6.png";